/* eslint-disable */
var $ = require('jquery');

$('table').wrap('<div style="oveflow: auto;"></div>');
